<template>
  <ion-page id="shared-board">

    <!-- <audio id="move_sound" src="assets/sounds/another_move_sound.mp3"></audio> -->
    <!-- <audio id="chat_sound" src="assets/sounds/chat.mp3"></audio> -->

    <AlertReplacement :alertInfo="alertInfo" :trigger="alertTrigger"
            @alert-result="alertResult"></AlertReplacement>

    <ion-content>

      <!-- INITIAL CONNECT SCREEN -->
      <div v-show="showState == SHOW_JOIN_ROOM"  :style="styleOneFrame"
              :class="{ 'text-dark' : isDark,'text-light' : !isDark }" >
        <ion-item>
          <h5>{{ message }}</h5>
        </ion-item>

        <ion-item>
          <ion-input label="Coach Email" label-placement="fixed" 
                    placeholder="Coach's Email Address" :value="email"
                    @ionInput="emailInputChange">
          </ion-input>
        </ion-item>

        <ion-item>
          <ion-input label="Room Name" label-placement="fixed" 
                    placeholder="Enter room name given by coach" :value="roomName"
                    @ionInput="roomInputChange">
          </ion-input>
        </ion-item>

        <ion-item>  
          <ion-input label="Your Name" label-placement="fixed" 
              placeholder="Your name to use in room" :value="displayName"
              @ionInput="displayNameInputChange">
          </ion-input>
        </ion-item>

        <ion-item>
          <ion-checkbox justify="start" @ionChange="toggleCheckAudioVideo()" :checked="enableVoiceChat" >
            <i>Enable Voice Chat&nbsp;</i>
          </ion-checkbox>
        </ion-item>
      
        <ion-item>
          <ion-grid>
            <ion-row>
              <ion-col>
                <ion-button expand="block" size="large" @click="enterRoom('student')"
                    :disabled="displayName.length == 0 || email.length == 0 || roomName.length == 0">
                              Enter Room<br>As Student
                </ion-button>
              </ion-col>
              <ion-col>
                <ion-button color="danger" expand="block" size="large" @click="enterRoom('coach')" 
                    :disabled="!isCoach || displayName.length == 0 || email.length == 0 || roomName.length == 0">Enter Room<br>As Coach</ion-button>
              </ion-col>
            </ion-row>
          </ion-grid>
        </ion-item>
      </div>

      <div v-show="showState == SHOW_BUILD_BOARD || showState == SHOW_ROOM">
        <div id="the_board" :style="styleBoard">
          <div v-show="coachHasJoinedRoom || personIsCoach">
            <CMChessboard :fen="fen" :validMoves="availableMoves"
                      :sideCarPiece="sideCarPiece"
                      :orientation="orientation" 
                      :setSquareColor="mainSquareColorArray"
                      :flagBadMove=true
                      :animateOnePly="animateFen" 
                      :hint="hintFen"
                      :arrows="arrowPairs"
                      :sparePieces="sparePieces"
                      :boardSize="boardSize" 
                      :doEmitEveryMove="doEmitEveryMove"
                      :canPromoteToAnyPiece=true
                      @board-move="boardMove" 
                      @move-made="moveMade"
                      />
          </div>
          <div v-show="!coachHasJoinedRoom && !personIsCoach">
            <ion-item>
              <h2></h2>
            </ion-item>
            <ion-item color="warning">
              <h2>Waiting for Coach to enter room</h2>
            </ion-item>
          </div>
        </div>
        <div v-show="(!whiteToMove && orientation=='white') || (whiteToMove && orientation=='black')" id="top_move" :style="styleTopMove" :key="!whiteToMove">
        </div>
        <div v-show="(whiteToMove && orientation=='white') || (!whiteToMove && orientation=='black')" id="bottom_move" :style="styleBottomMove" :key="whiteToMove">
        </div>
      </div>

      <!-- BOARD POSITION BUILDER -->
      <div v-show="showState == SHOW_BUILD_BOARD">
        <div :style="styleClipContainer" >
          <div :style="styleClipBoard">
            <CMChessboard :fen="selectorFen" 
                    :isPiecePicker=true
                    orientation="white" 
                    :flagBadMove=true
                    :setSquareColor="squareColorArray"
                    :boardSize="boardSize" @board-move="boardSelector" />
          </div>
        </div>
      </div>

      <!-- GENERAL SHARED ROOM SCREEN -->
      <div v-show="showState == SHOW_ROOM">

        <div  id="the_chatwindow" 
                    :style="styleChatWindow" 
                    :class="{ 'text-dark' : isDark, 
                              'text-light' : !isDark, 
                              'chat-window-dark' : isDark,
                              'chat-window-light' : !isDark }">
          
          <!-- VIDEO -- TESTING -->
          <div v-if="showAudioVideo">
            <div id="audio-videos">
              <div v-show="showVideo">
                <video id="localVideo" playsinline autoplay="true" muted="muted" class="video-player"></video>
                <span v-show="!personIsCoach">
                  <video id="remoteVideo" autoplay playsinline class="video-player"></video>
                </span>
              </div>
              <div v-show="!showVideo">
                <audio id="localAudio" playsinline autoplay="true" muted="muted" class="audio-player"></audio>
                <span v-show="!personIsCoach">
                  <audio id="remoteAudio" autoplay playsinline class="audio-player"></audio>
                </span>
              </div>
            </div>
          </div>

          <div v-for="item in chatDisplayArray" v-bind:key="item.id">
            <div v-if="item.type == 'welcome'" class="chat-welcome">
              {{ item.text }} to {{ roomName }}
            </div>
            <div v-if="item.type == 'coach' || item.type == 'student'" class="chat-bubble"
                    :class="{ 'chat-other-dark' : isDark, 'chat-other-light' : !isDark}">
              {{ item.name }}: {{ item.text }}
            </div>       
            <div v-if="item.type == 'me_coach' || item.type == 'me_student'" class="chat-bubble"
                    :class="{ 'chat-me-dark' : isDark, 'chat-me-light' : !isDark}">
              {{ item.text }}
            </div>    

          </div>
          <!-- add 0px height invisible element. have program scroll down it to -->
          <div id="bottom-element" class="invisible-bottom-element"></div>
        </div>

        <div  v-show="showEngineScores" id="the_engine_score" :style="styleEngineScores" 
                        :class="{ 'chat-me-dark' : isDark, 'chat-me-light' : !isDark}">
          <div v-html="scoreDisplayString"></div>
        </div>

        <div v-show="showSessionTimer" id="the_session_timer" :style="styleSessionClock" 
                :class="{ 'chat-me-dark' : isDark, 'chat-me-light' : !isDark}">
          {{ sessionTimerString }}
        </div>

        <div id="the_movehistory" :style="styleMoveHistory" 
                        :class="{ 'text-dark' : isDark, 'text-light' : !isDark }">
          <div v-show="showMoves">
            <RepTreeNewView 
                :treeDisplay="treeDisplay"
                :treeTrigger="treeTrigger" 
                @move-click="repTreeMoveClick"
                @branch-click="repTreeBranchClick"/>
          </div>
          <div v-show="!showMoves">
            <LearnMarkup 
                  :color="learnMarkupColor"
                  :action="learnMarkupAction"
                  @learn-markup-change="learnMarkupChange"/>
          </div>
        </div>

        <div id="the_sendwindow" 
                    :style="styleSendText" 
                    :class="{ 'text-dark' : isDark, 'text-light' : !isDark }">
          <ion-item>
      
            <ion-input type="text"  placeholder="Enter Chat Message" :value="chatMessage"
                    @ionInput="chatMessageInputChange" @keyup.enter="sendTypedMessage()">
            </ion-input>
            <ion-buttons slot="end">
              <ion-button  size="small" @click="sendTypedMessage()">
                <ion-icon :icon="sendOutline" slot="icon-only" ></ion-icon>
              </ion-button>
              <span v-show="audioIsOn && !audioIsMuted">
                <ion-button size="small" @click="setMicMuted(true)">
                  <ion-icon :icon="micOutline" slot="icon-only" ></ion-icon>
                </ion-button>
              </span>
              <span v-show="audioIsOn && audioIsMuted">
                <ion-button size="small" @click="setMicMuted(false)">
                  <ion-icon :icon="micOffOutline" slot="icon-only" ></ion-icon>
                </ion-button>
              </span>
          </ion-buttons>
          
          </ion-item>
        </div>
      </div>

      <ActionSheet heading="Options" :items="actionSheetButtons" 
                  :trigger="actionSheetTrigger"
                  @action-sheet-result="actionSheetResult">
      </ActionSheet>
    </ion-content>
    <Toolbar :elements="toolbarElements" :trigger="toolbarTrigger"        
                        @toolbar-click="toolbarClick"/>
  </ion-page>
</template>

<script setup>

// https://github.com/shanet/WebRTC-Example

// dude works with brad traversy
// https://www.youtube.com/watch?v=QsH8FL0952k
// https://github.com/divanov11/PeerChat

// multiple peer code
// https://github.com/webrtc/samples/blob/gh-pages/src/content/peerconnection/multiple/js/main.js


import { IonCheckbox, IonIcon, IonGrid,IonRow,IonCol,IonButton,IonButtons,IonItem,IonInput,IonPage, IonContent, modalController } from '@ionic/vue';

import { arrowUndoOutline,brushOutline, colorPaletteOutline, swapVerticalOutline, arrowBackOutline,arrowForwardOutline,arrowUpOutline, caretBackOutline,caretForwardOutline,micOutline, micOffOutline, sendOutline, timer} from 'ionicons/icons';

import { Chess, validateFen } from '@/ts/chess.ts'
import { buildPieceLocationStrings, getPieceSetName , columnToNumber, buildAvailableMoves,
  listOfSquaresWithNewPieces, buildCastleString } from '@/composables/blindfoldSupport.js'

import { ref, watch , onMounted, onBeforeUnmount, onUnmounted, createElementBlock } from 'vue';
import ModalLearnPreferences from '@/components/ModalLearnPreferences.vue'
import ModalErrorMessage from '@/components/ModalErrorMessage.vue'
import CMChessboard from '@/components/CMChessboard.vue'
import AlertReplacement from '@/components/AlertReplacement.vue'
import ActionSheet from '@/components/ActionSheet.vue'
import ModalGenericMultiList from '@/components/ModalGenericMultiList.vue'
import LearnMarkup from '@/components/LearnMarkup.vue'

import Toolbar from '@/components/Toolbar.vue';
import MoveHistory from '@/components/MoveHistory.vue'
import RepTreeNewView from '@/components/RepTreeNewView.vue';

import { findToolbarElement, setToolbarElementDisabledFlag, 
                  setToolbarElementLabel, setAllToolbarElementsDisabled, restoreAllToolbarElementsDisabled} 
              from '@/composables/toolbarSupport.js'

import { useGetData , getLichessData, generateErrorAlertText } from '@/composables/getData.js'

import { useConnectionStore } from '@/stores/connectionStore';
import { useWindowSizeStore } from '@/stores/windowSizeStore';
import { doStartupCheck } from '@/composables/startupCheck.js'
import { availableWidthHeight, calculateChessBoardRect, isScreenPortraitOrientation } 
            from '@/composables/screenSize'
  
const MOVEHISTORY_FONTSIZE = 16
const MOVEHISTORY_HEIGHT =  MOVEHISTORY_FONTSIZE * 1.2 + 4

const WHO_MOVE_HEIGHT = 50
const WHO_MOVE_WIDTH = 16

const SESSION_TIMER_WIDTH = 70

var chess = new Chess()

// const pgn = [
//   '[Event "Casual Game"]',
//   '[Site "Berlin GER"]',
//   '[Date "1852.??.??"]',
//   '[EventDate "?"]',
//   '[Round "?"]',
//   '[Result "1-0"]',
//   '[White "Adolf Anderssen"]',
//   '[Black "Jean Dufresne"]',
//   '[ECO "C52"]',
//   '[WhiteElo "?"]',
//   '[BlackElo "?"]',
//   '[PlyCount "47"]',
//   '',
//   '1.e4 e5 2.Nf3 Nc6 3.Bc4 Bc5 4.b4 Bxb4 5.c3 Ba5 6.d4 exd4 7.O-O',
//   'd3 8.Qb3 Qf6 9.e5 Qg6 10.Re1 Nge7 11.Ba3 b5 12.Qxb5 Rb8 13.Qa4',
//   'Bb6 14.Nbd2 Bb7 15.Ne4 Qf5 16.Bxd3 Qh5 17.Nf6+ gxf6 18.exf6',
//   'Rg8 19.Rad1 Qxf3 20.Rxe7+ Nxe7 21.Qxd7+ Kxd7 22.Bf5+ Ke8',
//   '23.Bd7+ Kf8 24.Bxe7# 1-0',
// ].join('\n')

const pgn = `[Event "?"]
[Site "?"]
[Date "?"]
[Round "?"]
[White "?"]
[Black "?"]
[Result "*"]
[FEN "8/8/4k3/8/8/4KQ2/8/8 w - - 0 1"]
[SetUp "1"]

1.Qf4 Ke7 2.Kd4 Ke6 3.Kc5 Ke7 4.Qf5 *
`

const connectionStore = useConnectionStore()

const isDark = ref(connectionStore.getDarkmode != "light")
const isCoach = ref(connectionStore.getCoach == "eval")

//console.log("COACH ",isCoach)



const menuTrigger = ref(0)

const TOOLBAR_DONE = 0
const toolbarTrigger = ref(0)

const windowSizeStore = useWindowSizeStore()
const windowSizeRef = ref({ width : windowSizeStore.getWindowSize['width'],
                      height : windowSizeStore.getWindowSize['height'] })
const boardSize = ref(100)

const sparePieces = ref("build")

const email = ref(connectionStore.getLearnCoachEmail)
const roomName = ref(connectionStore.getLearnRoomName)
const displayName = ref(connectionStore.getLearnDisplayName)

// see if there are URL parameters
const urlAction = localStorage.getItem("url_a")
if (urlAction == "learn") {
  const url_email = localStorage.getItem("url_email")
  const url_room = localStorage.getItem("url_room")
  const url_name = localStorage.getItem("url_name")
  if (url_email != null && url_email.length > 0)
    email.value = url_email
  if (url_room != null && url_room.length > 0)
    roomName.value = url_room
  if (url_name != null && url_name.length > 0)
    displayName.value = url_name
}

const chatMessage = ref("")
const audioIsOn = ref(false)
const muteAtStart = false
const audioIsMuted = ref(muteAtStart)

const checkAudioVideo = ref(connectionStore.getCheckAudioVideo)
const enableVoiceChat = ref(checkAudioVideo.value == "audio")
console.log("enable voice chat",enableVoiceChat.value)

var remoteIndex = 0

// this will uniquely ID the connection for Peer-to-Peer stuff
const myUUID = connectionStore.getSessionUUID
//console.log("MY UUID",myUUID)

var inRecents = false

var treeDisplay = ref([])
const treeTrigger = ref(0)

// limit chat to # of display items
const chatDisplayCount = 100
const bigChatDisplayArray = [ { id : 0, name : "", type : "welcome", text : "Welcome" } ]
const chatDisplayArray = ref([bigChatDisplayArray[0]])

const joinRoomMessage = "Let's Start Learning!"
const message = ref(joinRoomMessage)

var move_sound = null
var chat_sound = null
var audioContext = null

const moveHistoryStack = ref([])
const moveHistoryTrigger = ref(0)

const developmentURL = 'ws://chessvis.ddns.net:4200'
const contaboURL = 'wss://www.chessvis.com/'
var URL = (process.env.NODE_ENV === 'production') ? contaboURL : developmentURL

// force development
//URL = developmentURL

// force production
//URL = contaboURL

var socket = null

const INITIAL_FEN_ENGINE_SCORES = {
    "fen": "rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1",
    "r": "p38,p33,p28,p22\td2d4,g1f3,c2c4,e2e4"
}
const INITIAL_FEN = "rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1"
const EMPTY_FEN = "8/8/8/8/8/8/8/8 w - - 0 1"

const SELECTOR_FEN_LANDSCAPE = "rR6/nN6/bB6/qQ6/kK6/pP6/8/8 w - - 0 1"
const SELECTOR_FEN_PORTRAIT = "rnbqkp2/RNBQKP2/8/8/8/8/8/8 w - - 0 1"

var isPortrait = true

const selectorFen = ref(SELECTOR_FEN_PORTRAIT)
const fen = ref(INITIAL_FEN)

var blankAppendTrigger = " "
var orientation = ref("white")
const availableMoves = ref([])
const availableMovesForBuilder = [ { from : "any"}]
var saveAvailableMoves = []

const hintFen = ref([])
const animateFen = ref([])
const squareColorArray = ref([])
const mainSquareColorArray = ref([])
var arrowPairs = ref([])

var isPGN = false
var isPGNDisplayed = false
var pgnSans = ""
var pgnIndex = 0

var currentSelectedMoveIndex = 0

const doEmitEveryMove = ref(true)

const sideCarPiece = ref("")
var whiteToMove = ref(true)
var positionIsValid = true

var completeFen = INITIAL_FEN
const coachHasJoinedRoom = ref(false)

var personIsCoach = false
var personType = ""

// learn markup
const learnMarkupDefaults = connectionStore.getMarkupDefaults
const learnMarkupDefaultPieces = learnMarkupDefaults.split(",")
const learnMarkupColor = ref(learnMarkupDefaultPieces[0])
const learnMarkupAction = ref(learnMarkupDefaultPieces[1])

var learnMarkerArray = []
var learnArrowArray = []
var learnArrowFromSquare = ""

// engine scores
//    the map will have a key of "fen" and the stored engine stores as the value
var engineScoreMap = new Map()
//    the chess object to determine the SAN
var chessForEngineScore = null
const scoreDisplayString = ref("")
const showEngineScores = ref(false)

// used to send the ping
var absoluteSecondsCounter = 0
const pingSeconds = 55

// session timer
const showSessionTimer = ref(false)
var sessionTimerStartTime = 0
var timerCanStop = false
const sessionTimerString = ref("XYZ")
var sessionTimerAvailableForStudent = false

// sounds mute/play
var muteMoveSound = false
var muteChatSound = false
var soundTitle = "Mute Sounds?"
const roomSoundString = connectionStore.getRoomSounds
updateMutes(roomSoundString)

// video/audio
var peerStudentConnection = null
var localStream = null
var peerMap = new Map()
var didStartPeerConnections = false

var localAudioVideo = null

var peerConnectionConfig = { 'iceServers': [] }

const alertInfo = ref({})
const alertTrigger = ref(0)

const SHOW_JOIN_ROOM = 0
const SHOW_ROOM = 1
const SHOW_BUILD_BOARD = 2

const showMoves = ref(true)

const showAudioVideo = ref(true)

// show video image - easier to test
const showVideo = ref(false)

const showState = ref(SHOW_JOIN_ROOM)

const TOOLBAR_BUILD_FEN = 30
const TOOLBAR_BUILD_WHO_MOVE = 31
const TOOLBAR_BUILD_PGN = 32
const TOOLBAR_BUILD_DONE = 33
const TOOLBAR_BUILD_DONE_FROM_PGN = 39

const toolbarBuildBoardElements = [
{ index : TOOLBAR_BUILD_FEN, label : "Board Source" , disabled : false, collapse:false},
{ index : TOOLBAR_BUILD_WHO_MOVE, label : "White To Move" , disabled : false, collapse:false},
{ index : TOOLBAR_BUILD_PGN, label : "Paste Game" , disabled : false, collapse:false},
{ index : TOOLBAR_BUILD_DONE, label : "Done" , disabled : false, collapse:false},
]

const TOOLBAR_MAIN_BACK = 0
const TOOLBAR_MAIN_FORWARD = 1
const TOOLBAR_MAIN_MARKUP = 2
const TOOLBAR_MAIN_BACK_TO_GAME = 3
const TOOLBAR_MAIN_COACH = 4
const TOOLBAR_MAIN_STUDENT = 5

const toolbarMainElements = [
{ index : TOOLBAR_MAIN_BACK, label : "" , icon:arrowBackOutline,disabled : false, collapse:false},
{ index : TOOLBAR_MAIN_FORWARD, label : "" , icon:arrowForwardOutline, disabled : false, collapse:false},
{ index : TOOLBAR_MAIN_MARKUP, label : "Mark-Up" , icon:colorPaletteOutline, disabled : false, collapse:false},
{ index : TOOLBAR_MAIN_BACK_TO_GAME, label : "Game" , icon:arrowUpOutline, disabled : true, collapse:false},
]

const toolbarMainCoachElement =  { index : TOOLBAR_MAIN_COACH, label : "Coach" , hasAction : true}
const toolbarMainStudentElement =  { index : TOOLBAR_MAIN_STUDENT, label : "Student" , hasAction : true}

const toolbarElements = ref([])

const actionSheetTrigger = ref(0)
const ACTION_COACH_OPTION_INDEX = 10
const ACTION_COACH_OPTION_SESSION_TIMER = 10
const ACTION_COACH_OPTION_LEAVE_ROOM = 11
const ACTION_COACH_OPTION_ENGINE = 12
const ACTION_COACH_OPTION_SOUNDS = 13
const ACTION_COACH_OPTION_COPY = 14
const ACTION_COACH_OPTION_BUILD_BOARD = 15
const ACTION_COACH_OPTION_FLIP_BOARD = 16

var coachActionSheetButtons = [
    { text: "Start Session Timer", data: { index: ACTION_COACH_OPTION_SESSION_TIMER } },
    { text: "Leave Room", data: { index: ACTION_COACH_OPTION_LEAVE_ROOM } },
    { text: "Enable Engine Scores", data: { index: ACTION_COACH_OPTION_ENGINE } },
    { text: "Mute Sounds", data: { index: ACTION_COACH_OPTION_SOUNDS } },
    { text: "Copy to Clipboard", data: { index: ACTION_COACH_OPTION_COPY } },
    { text: "Set Up Board", data: { index: ACTION_COACH_OPTION_BUILD_BOARD } },
    { text: "Flip Board", data: { index: ACTION_COACH_OPTION_FLIP_BOARD } },

    { text: 'Cancel', role: 'cancel',data: { index : -1}}
  ]

const ACTION_STUDENT_OPTION_INDEX = 20
const ACTION_STUDENT_OPTION_SESSION_TIMER = 20
const ACTION_STUDENT_OPTION_LEAVE_ROOM = 21
const ACTION_STUDENT_OPTION_SOUNDS = 22
const ACTION_STUDENT_OPTION_COPY = 23
const ACTION_STUDENT_OPTION_BUILD_BOARD = 24
const ACTION_STUDENT_OPTION_FLIP_BOARD = 25


var studentActionSheetButtons = [
    { text: "Show Session Timer", data: { index: ACTION_STUDENT_OPTION_SESSION_TIMER } },
    { text: "Leave Room", data: { index: ACTION_STUDENT_OPTION_LEAVE_ROOM } },
    { text: "Mute Sounds", data: { index: ACTION_STUDENT_OPTION_SOUNDS } },
    { text: "Copy Board/Moves", data: { index: ACTION_STUDENT_OPTION_COPY } },
    { text: "Set Up Board", data: { index: ACTION_STUDENT_OPTION_BUILD_BOARD } },
    { text: "Flip Board", data: { index: ACTION_STUDENT_OPTION_FLIP_BOARD } },
    { text: 'Cancel', role: 'cancel',data: { index : -1}}
  ]

const actionSheetButtons = ref([])

const styleOneFrame = ref({
   position : "absolute",
   "overflow-y" : "scroll",
   top : "0px",
   left : "100px",
   width: "100px",
   height : "100px"
 })

 const styleBoard = ref({
  position : "absolute",
  top : "0px",
  left : "100px",
  width: "100px",
  height : "100px"
})

const styleTopMove = ref({
  position : "absolute",
  top : "0px",
  left : "100px",
  width: "100px",
  height : "100px",
  "background-color" : "steelblue"
})

const styleBottomMove = ref({
  position : "absolute",
  top : "0px",
  left : "100px",
  width: "100px",
  height : "100px",
  "background-color" : "steelblue"
})


const styleClipContainer = ref({
  position : "absolute",
  top : "0px",
  left : "100px",
  width: "100px",
  height : "100px",
  overflow : "hidden"
})

const styleClipBoard = ref({
  position : "absolute",
  top : "0px",
  left : "100px",
  width: "100px",
  height : "100px"
})

const styleChatWindow = ref({
  position : "absolute",
  "overflow-y" : "scroll",
  top : "0px",
  left : "100px",
  width: "100px",
  height : "100px",
  "margin-bottom" : "0px",
})

const styleSendText = ref({
  position : "absolute",
  "overflow-y" : "scroll",
  top : "0px",
  left : "100px",
  width: "100px",
  height : "100px",
  "text-align" : "center"

})

const styleMoveHistory = ref({
  position : "absolute",
  "overflow-y" : "scroll",
  top : "0px",
  left : "100px",
  width: "100px",
  height : "100px",
  "font-size" : MOVEHISTORY_FONTSIZE + "px",
  "text-align" : "left",
  "line-height" : "1.2em",
  // "color" : "white"
  "margin-top" : "10px"
})

const styleEngineScores = ref({
  position : "absolute",
  "overflow-y" : "scroll",
  top : "100px",
  left : "100px",
  width: "100px",
  height : "100px",
  "font-size" : MOVEHISTORY_FONTSIZE + "px",
  "text-align" : "left",
  "line-height" : "1.2em",
  "padding-left" : "3px",
  "padding-top" : "2px"
})

const styleSessionClock = ref({
  position : "absolute",
  "overflow-y" : "scroll",
  top : "100px",
  left : "100px",
  width: "100px",
  height : "100px",
  "font-size" : MOVEHISTORY_FONTSIZE + "px",
  "text-align" : "right",
  "line-height" : "1.2em",
  "border-left": "4px solid black",
  "padding-right" : "3px",
  "padding-top" : "2px"

})

 //updateWidthHeights()
 doStartupCheck(false,afterStartupCallbackRoutine)

 function incrementAppendTrigger() {
  if (blankAppendTrigger.length > 64)
    blankAppendTrigger = ""
  blankAppendTrigger += " "
}


 onMounted(() => {

  timerCanStop = false
  startTimer()

  //getIceServers()
  //console.log("mounted")

  //getTurnServers()

  // move_sound = document.getElementById("move_sound");
  // chat_sound = document.getElementById("chat_sound");

  // https://www.thecodecreative.com/blog/autoplay-policy-in-google-chrome
  audioContext = new (window.AudioContext || window.webkitAudioContext)();
  console.log("on mounted",audioContext)
  console.log("audio state ",audioContext.state)


  fen.value = INITIAL_FEN
  loadRepTreeFromChessHistory(INITIAL_FEN,[],0,true,false)

  selectorFen.value = SELECTOR_FEN_PORTRAIT + blankAppendTrigger
})

onBeforeUnmount(() => {
    //console.log("in onBeforeUnmount")
    timerCanStop = true

    if (socket != null)
      leaveRoom()

  })

onUnmounted(() => {
})

watch(() => windowSizeStore.getWindowSize, () => {
    //console.log('*********** window size changes detected')
    windowSizeRef.value = { width : windowSizeStore.getWindowSize['width'],
                      height : windowSizeStore.getWindowSize['height'] }
    //console.log("*** logoff new window size",windowSizeRef.value)
    menuTrigger.value++
    updateWidthHeights()
  })

  const openErrorModal = async (programName,errorMessage) => {
    const modal = await modalController.create({
      component: ModalErrorMessage,
      componentProps: {
        type : "commError",
        program : programName ,
        errorMessage : errorMessage
      }
    });

    modal.present();

    const { data, role } = await modal.onWillDismiss();
  };

  // ADD Modal
  const learnPreferencesModal = async (action) => {
    const modal = await modalController.create({
      component: ModalLearnPreferences,
      componentProps: {
        action : "add",
        min : 800,
        max : 1200,
        color : "white",
        name : "blah",
        editPercentage : 1
      }
    });

    modal.present();

    const { data, role } = await modal.onWillDismiss();

    if (role === 'confirm') {
    }
      
  };

function afterStartupCallbackRoutine(stuffChanged,errorProgram,errorEntry) {
  if (errorProgram != null)
      openErrorModal(errorProgram,errorEntry)
  menuTrigger.value++
  updateWidthHeights()
}

function updateWidthHeights() {

  const availableSpace = availableWidthHeight()
  const oneframePositionTop = availableSpace.topIndent
  const oneframePositionLeft = availableSpace.leftRightIndent + availableSpace.leftIndent
  const oneframeHeight = availableSpace.height - oneframePositionTop
  const oneframeWidth = availableSpace.width - availableSpace.leftRightIndent * 2

  // used for the connect screen
  styleOneFrame.value.height = oneframeHeight + "px"
  styleOneFrame.value.width = oneframeWidth + "px"
  styleOneFrame.value.top = oneframePositionTop + "px"
  styleOneFrame.value.left = oneframePositionLeft + "px"

  // used for the board & chat
  isPortrait = isScreenPortraitOrientation(availableSpace)
  const boundaries = (isPortrait) ? calculatePortraitWidthHeights(availableSpace) :
                                    calculateLandscapeWidthHeights(availableSpace)
  updateStyleObjects(boundaries)
  incrementAppendTrigger()
  selectorFen.value = ((isPortrait) ? SELECTOR_FEN_PORTRAIT : SELECTOR_FEN_LANDSCAPE) + blankAppendTrigger
}

function updateStyleObjects(boundaries) {
  boardSize.value = boundaries['board'].height

  styleBoard.value.height = boundaries['board'].height + "px"
  styleBoard.value.width = boundaries['board'].width + "px"
  styleBoard.value.top = boundaries['board'].top + "px"
  styleBoard.value.left = boundaries['board'].left + "px"

  styleChatWindow.value.height = boundaries['chat'].height + "px"
  styleChatWindow.value.width = boundaries['chat'].width + "px"
  styleChatWindow.value.top = boundaries['chat'].top + "px"
  styleChatWindow.value.left = boundaries['chat'].left + "px"

  styleMoveHistory.value.height = boundaries['history'].height + "px"
  styleMoveHistory.value.width = boundaries['history'].width + "px"
  styleMoveHistory.value.top = boundaries['history'].top + "px"
  styleMoveHistory.value.left = boundaries['history'].left + "px"

  styleEngineScores.value.height = boundaries['score'].height + "px"
  styleEngineScores.value.width = boundaries['score'].width + "px"
  styleEngineScores.value.top = boundaries['score'].top + "px"
  styleEngineScores.value.left = boundaries['score'].left + "px"

  styleSessionClock.value.height = boundaries['clock'].height + "px"
  styleSessionClock.value.width = boundaries['clock'].width + "px"
  styleSessionClock.value.top = boundaries['clock'].top + "px"
  styleSessionClock.value.left = boundaries['clock'].left + "px"

  styleSendText.value.height = boundaries['send'].height + "px"
  styleSendText.value.width = boundaries['send'].width + "px"
  styleSendText.value.top = boundaries['send'].top + "px"
  styleSendText.value.left = boundaries['send'].left + "px"

  styleClipContainer.value.height = boundaries['clipContainer'].height + "px"
  styleClipContainer.value.width = boundaries['clipContainer'].width + "px"
  styleClipContainer.value.top = boundaries['clipContainer'].top + "px"
  styleClipContainer.value.left = boundaries['clipContainer'].left + "px"

  styleClipBoard.value.height = boundaries['clipBoard'].height + "px"
  styleClipBoard.value.width = boundaries['clipBoard'].width + "px"
  styleClipBoard.value.top = boundaries['clipBoard'].top + "px"
  styleClipBoard.value.left = boundaries['clipBoard'].left + "px"

  styleTopMove.value.height = boundaries['topMove'].height + "px"
  styleTopMove.value.width = boundaries['topMove'].width + "px"
  styleTopMove.value.top = boundaries['topMove'].top + "px"
  styleTopMove.value.left = boundaries['topMove'].left + "px"

  styleBottomMove.value.height = boundaries['bottomMove'].height + "px"
  styleBottomMove.value.width = boundaries['bottomMove'].width + "px"
  styleBottomMove.value.top = boundaries['bottomMove'].top + "px"
  styleBottomMove.value.left = boundaries['bottomMove'].left + "px"
}

function calculatePortraitWidthHeights(availableSpace) {

  const hardcodedVerticalSpace = 250

  const availableSpaceForBoard = { width : availableSpace.width - WHO_MOVE_WIDTH,
                height : availableSpace.height / 2,
                isPortrait : true }

  const boardDimensions = calculateChessBoardRect(availableSpaceForBoard,1.0)

  const boardHeight = boardDimensions.height
  const boardWidth = boardDimensions.width
  const boardPositionTop = boardDimensions.y
  const boardPositionLeft = boardDimensions.x + availableSpace.leftRightIndent

  const topMoveHeight = WHO_MOVE_HEIGHT
  const topMoveWidth = WHO_MOVE_WIDTH
  const topMovePositionTop = boardPositionTop
  const topMovePositionLeft = boardPositionLeft + boardWidth

  // grab the vertical if either engines or timer are showing
  const engineScoreTop = boardPositionTop + boardHeight
  const engineScoreLeft = availableSpace.leftRightIndent
  const engineScoreWidth = availableSpace.width - engineScoreLeft - SESSION_TIMER_WIDTH
  const engineScoreHeight = (showEngineScores.value || showSessionTimer.value) ? MOVEHISTORY_HEIGHT : 0

  const sessionClockTop = boardPositionTop + boardHeight
  const sessionClockLeft = engineScoreLeft + engineScoreWidth
  const sessionClockWidth = SESSION_TIMER_WIDTH
  const sessionClockHeight = (showEngineScores.value || showSessionTimer.value) ? MOVEHISTORY_HEIGHT : 0

  const moveHistoryPositionTop = engineScoreTop + engineScoreHeight
  const moveHistoryPositionLeft = availableSpace.leftRightIndent
  const moveHistoryHeight = (availableSpace.height - moveHistoryPositionTop) * .4
  const moveHistoryWidth = availableSpace.width - availableSpace.leftRightIndent * 2

  const chatWindowPositionTop = moveHistoryPositionTop + moveHistoryHeight
  const chatWindowPositionLeft = moveHistoryPositionLeft
  const chatWindowHeight = availableSpace.height - chatWindowPositionTop - MOVEHISTORY_HEIGHT * 2.5
  const chatWindowWidth = moveHistoryWidth

  const sendTextPositionTop = chatWindowPositionTop + chatWindowHeight
  const sendTextPositionLeft = moveHistoryPositionLeft
  const sendTextHeight = availableSpace.height - sendTextPositionTop
  const sendTextWidth = moveHistoryWidth

  // for the board builder
  const clipPositionTop = moveHistoryPositionTop
  const clipPositionLeft = boardPositionLeft
  const clipHeight = boardHeight * 2.0/8.0
  const clipWidth = boardWidth * 6.0/8.0

  const result = { 
    clipContainer : {
      width : clipWidth,
      height : clipHeight,
      left : clipPositionLeft + availableSpace.leftIndent,
      top : clipPositionTop+ availableSpace.topIndent
    },
    clipBoard : {
      width : boardWidth,
      height : boardHeight,
      left : + availableSpace.leftIndent,
      top : 0
    },
    board : {
      width : boardWidth,
      height : boardHeight,
      left : boardPositionLeft + availableSpace.leftIndent,
      top : boardPositionTop+ availableSpace.topIndent
    },
    topMove : {
      width : topMoveWidth,
      height : topMoveHeight,
      left : topMovePositionLeft + availableSpace.leftIndent,
      top : topMovePositionTop+ availableSpace.topIndent
    },
    bottomMove : {
      width : topMoveWidth,
      height : topMoveHeight,
      left : topMovePositionLeft + availableSpace.leftIndent,
      top : boardPositionTop + boardHeight - topMoveHeight + availableSpace.topIndent
    },
    chat : {
      width : chatWindowWidth,
      height : chatWindowHeight,
      left : chatWindowPositionLeft + availableSpace.leftIndent,
      top : chatWindowPositionTop+ availableSpace.topIndent
    },
    history : {
      width : moveHistoryWidth,
      height : moveHistoryHeight,
      left : moveHistoryPositionLeft + availableSpace.leftIndent,
      top : moveHistoryPositionTop+ availableSpace.topIndent
    },
    score : {
      width : engineScoreWidth,
      height : engineScoreHeight,
      left : engineScoreLeft + availableSpace.leftIndent,
      top : engineScoreTop+ availableSpace.topIndent
    },
    clock : {
      width : sessionClockWidth,
      height : sessionClockHeight,
      left : sessionClockLeft + availableSpace.leftIndent,
      top : sessionClockTop+ availableSpace.topIndent
    },
    send : {
      width : sendTextWidth,
      height : sendTextHeight,
      left : sendTextPositionLeft + availableSpace.leftIndent,
      top : sendTextPositionTop+ availableSpace.topIndent
    },
  }
  return (result)
}

function calculateLandscapeWidthHeights(availableSpace) {

  const availableSpaceForBoard = { width : (availableSpace.width - WHO_MOVE_WIDTH) / 2,
              height : availableSpace.height ,
              isPortrait : false }
  const boardDimensions = calculateChessBoardRect(availableSpaceForBoard,1.0)

  const boardHeight = boardDimensions.height
  const boardWidth = boardDimensions.width
  const boardPositionTop = boardDimensions.y
  const boardPositionLeft = boardDimensions.x + availableSpace.leftRightIndent

  const topMoveHeight = WHO_MOVE_HEIGHT
  const topMoveWidth = WHO_MOVE_WIDTH
  const topMovePositionTop = boardPositionTop
  const topMovePositionLeft = boardPositionLeft + boardWidth

  // grab the vertical if either engines or timer are showing
  const engineScoreTop = 0
  const engineScoreLeft = boardPositionLeft + boardWidth + topMoveWidth + availableSpace.leftRightIndent
  const engineScoreWidth = availableSpace.width - engineScoreLeft - SESSION_TIMER_WIDTH
  const engineScoreHeight = (showEngineScores.value || showSessionTimer.value) ? MOVEHISTORY_HEIGHT : 0

  const sessionClockTop = 0
  const sessionClockLeft = engineScoreLeft + engineScoreWidth
  const sessionClockWidth = SESSION_TIMER_WIDTH
  const sessionClockHeight = (showEngineScores.value || showSessionTimer.value) ? MOVEHISTORY_HEIGHT : 0

  const moveHistoryPositionTop = engineScoreHeight
  const moveHistoryPositionLeft = boardPositionLeft + boardWidth + topMoveWidth + availableSpace.leftRightIndent
  const moveHistoryHeight = (availableSpace.height - engineScoreHeight) * .4
  const moveHistoryWidth = availableSpace.width - moveHistoryPositionLeft

  const chatWindowPositionTop = moveHistoryPositionTop + moveHistoryHeight
  const chatWindowPositionLeft = boardPositionLeft + boardWidth + topMoveWidth + availableSpace.leftRightIndent
  const chatWindowHeight = availableSpace.height - chatWindowPositionTop - MOVEHISTORY_HEIGHT * 2.5
  const chatWindowWidth = availableSpace.width - chatWindowPositionLeft

  const sendTextPositionTop = chatWindowPositionTop + chatWindowHeight
  const sendTextPositionLeft = boardPositionLeft + boardWidth + topMoveWidth + availableSpace.leftRightIndent
  const sendTextHeight = availableSpace.height - sendTextPositionTop
  const sendTextWidth = availableSpace.width - sendTextPositionLeft

  // for the board builder
  const clipPositionTop = 0
  const clipPositionLeft = boardPositionLeft + boardWidth + topMoveWidth + availableSpace.leftRightIndent
  const clipHeight = boardHeight * 6.0/8.0
  const clipWidth = boardWidth * 2.0/8.0

  const result = { 
    clipContainer : {
      width : clipWidth,
      height : clipHeight,
      left : clipPositionLeft + availableSpace.leftIndent,
      top : clipPositionTop+ availableSpace.topIndent
    },
    topMove : {
      width : topMoveWidth,
      height : topMoveHeight,
      left : topMovePositionLeft + availableSpace.leftIndent,
      top : topMovePositionTop+ availableSpace.topIndent
    },
    bottomMove : {
      width : topMoveWidth,
      height : topMoveHeight,
      left : topMovePositionLeft + availableSpace.leftIndent,
      top : boardPositionTop + boardHeight - topMoveHeight + availableSpace.topIndent
    },
    clipBoard : {
      width : boardWidth,
      height : boardHeight,
      left : boardPositionLeft,
      top : boardPositionTop
    },
    board : {
      width : boardWidth,
      height : boardHeight,
      left : boardPositionLeft + availableSpace.leftIndent,
      top : boardPositionTop+ availableSpace.topIndent
    },
    chat : {
      width : chatWindowWidth,
      height : chatWindowHeight,
      left : chatWindowPositionLeft + availableSpace.leftIndent,
      top : chatWindowPositionTop+ availableSpace.topIndent
    },
    history : {
      width : moveHistoryWidth,
      height : moveHistoryHeight,
      left : moveHistoryPositionLeft + availableSpace.leftIndent,
      top : moveHistoryPositionTop+ availableSpace.topIndent
    },
    score : {
      width : engineScoreWidth,
      height : engineScoreHeight,
      left : engineScoreLeft + availableSpace.leftIndent,
      top : engineScoreTop+ availableSpace.topIndent
    },
    clock : {
      width : sessionClockWidth,
      height : sessionClockHeight,
      left : sessionClockLeft + availableSpace.leftIndent,
      top : sessionClockTop+ availableSpace.topIndent
    },
    send : {
      width : sendTextWidth,
      height : sendTextHeight,
      left : sendTextPositionLeft + availableSpace.leftIndent,
      top : sendTextPositionTop+ availableSpace.topIndent
    },
  }
  return (result)
}

function emailInputChange(ev) {
  const value = ev.target.value;
  email.value = value.trim()
}

  function roomInputChange(ev) {
    const value = ev.target.value;
    roomName.value = value.trim()
  }

  function displayNameInputChange(ev) {
    const value = ev.target.value;
    displayName.value = value.trim()
  }

function chatMessageInputChange(ev) {
  const value = ev.target.value;
  chatMessage.value = value.trim()
}

function openSocket() {
  //socket = new WebSocket(URL)
  socket = new WebSocket(URL, null, null, null, {rejectUnauthorized: false});

  socket.closedNormally = ""

  //console.log("**** SOCKET ",socket)
  socket.onerror = function(event) {
    alert("Connection to server failed. Please check your internet connection. If this continues, please contact support@chessvis.com")
    if (socket != null)
      socket.closedNormally = "error"
    return
  }

  socket.onopen =function(event){
    //console.log("*** socket open ",event)
    return
  }

  socket.onclose = function(event){
    //console.log("*** socket closed ",event)
    if (socket != null && socket.closedNormally == "") {
      leaveRoom()
      alert("Connection to Server was lost.\n\nPlease check your internet connection and then 'Re-Enter room' to reconnect")
    }
    return
  }

  // Listen for messages 
  socket.addEventListener("message", ({ data }) => {
      processMessageFromSocket(data)
  })
}

// send message to socket. track disconnect and stuff like that
function sendMessageToSocket(message) {
  if (socket != null) {
    //console.log("Socket state",socket.readyState)
    socket.send(message)
  }
}

function closeSocket() {
  if (socket != null) {
    socket.closedNormally = "yes"
    //console.log("closeSocket")
    socket.close()
    socket = null
  }
}

function playChatSound() {
  if (chat_sound == null)
    chat_sound = new Audio('assets/sounds/chat.mp3');
  //console.log("*** play chat sound ",chat_sound)
  chat_sound.play()
}

function playMoveSound() {
  if (move_sound == null)
    move_sound = new Audio('assets/sounds/another_move_sound.mp3');
  //console.log("*** play move sound ",move_sound)
  move_sound.play()
}

function pgnToTreeDisplay(pgn) {

  try {
    chess.loadPgn(pgn)
  } catch {
    setupAlert("Clipboard does not contain a valid PGN","","alert","bad")
    return
  }

  const chessHistory = chess.history({ verbose: true })
  //console.log("HISTORY ",chessHistory)

  const startingFen = (chessHistory.length > 0) ? chessHistory[0].before : INITIAL_FEN
  loadRepTreeFromChessHistory(startingFen,chessHistory,0,false,true)

  // take the tree and build up the PGN sans list
  var sans = []
  for (var i=1; i < treeDisplay.value[0].moves.length; i++)
    sans.push(treeDisplay.value[0].moves[i].move.san)
  pgnSans = sans.join(" ")
  pgnIndex = 0
  isPGN = true
  isPGNDisplayed = true
  setToolbarElementDisabledFlag(toolbarElements.value,TOOLBAR_MAIN_BACK_TO_GAME,true)
  toolbarTrigger.value++
  buildFenMessage()
}

function loadRepTreeFromChessHistory(startingFen,chessHistory,selectedIndex,firstCall,iMadeTheMove) {
  var updatedFen = startingFen

  const startingFenPieces = startingFen.split(" ")
  const startingPlyNumber = (startingFenPieces[1] == "w") ? 0 : 1

  var oneBranch = { indentLevel : 0, moves : [] }

  // initial clickable thing -- allow for PGN that is a game fragment
  const firstFen = (chessHistory.length > 0) ? chessHistory[0].before : startingFen

  if (selectedIndex == 0)
    updatedFen = firstFen

  var firstBranchElement = { index : 0, ply : -1, isOpen : false, selected : (selectedIndex == 0), parentIsOpen : false, 
            move :{  san : "First", fen : firstFen,
                first_move_not_addressed : 0, percent : 0, comment : '', canBranchAfterThisMove : false , branchIsOpen : false
              }
            }
  oneBranch.moves.push(firstBranchElement)
  for (var i=0; i < chessHistory.length; i++) {
    if (selectedIndex == i+1)
      updatedFen = chessHistory[i].after
    var oneBranchElement = { index : i+1, ply : i + startingPlyNumber, isOpen : false, selected :  (selectedIndex == i+1), parentIsOpen : (i == 0), 
            move : { san : chessHistory[i].san, fen : chessHistory[i].after, first_move_not_addressed : 0, 
                      percent : 0, comment : '', canBranchAfterThisMove : false , branchIsOpen : false} }
    oneBranch.moves.push(oneBranchElement)
  }
  treeDisplay.value = [oneBranch]
  //console.log("in loadreptree",treeDisplay.value)
  treeTrigger.value++

  //console.log("before get board ",fen.value,updatedFen)
  const currentLoad = chess.load(fen.value.trim())
  const currentBoard = chess.board()
  const updatedLoad = chess.load(updatedFen)
  const updatedBoard = chess.board()

  const currentFen = fen.value
  animateFen.value = [currentFen , updatedFen]

  const fenPieces = updatedFen.split(" ")
  whiteToMove.value = (fenPieces[1] == "w")
  //console.log("before GET AVILALBLE")
  getAvailableMoves(updatedFen,iMadeTheMove)
  //console.log("after GET AVILALBLE")
  currentSelectedMoveIndex = selectedIndex

  setTimeout(function() {
    const changedUCIs = listOfSquaresWithNewPieces(currentBoard,updatedBoard)
    mainSquareColorArray.value = []
    for (var i = 0; i < changedUCIs.length; i++)
      mainSquareColorArray.value.push({ square : changedUCIs[i] , color : "circle"})
    }, 250)
  setTimeout(function() {
    fen.value = updatedFen
    if (personIsCoach && showEngineScores.value)
        getMultiPV(fen.value)
    }, 500); 
  setTimeout(function() {
    mainSquareColorArray.value = []
    }, 1500)

    if (!firstCall && muteMoveSound == false) {
      playMoveSound()
    }

    setToolbarElementDisabledFlag(toolbarElements.value,TOOLBAR_MAIN_BACK, currentSelectedMoveIndex == 0)
    setToolbarElementDisabledFlag(toolbarElements.value,TOOLBAR_MAIN_FORWARD, currentSelectedMoveIndex >=  oneBranch.moves.length -1)
    toolbarTrigger.value++
}

function formatDate(date,separator) {
  const year = date.toLocaleString('default', {year: 'numeric'});
  const month = date.toLocaleString('default', {
    month: '2-digit',
  });
  const day = date.toLocaleString('default', {day: '2-digit'});

  return [year, month, day].join(separator);
}

function fenSansToTreeDisplay(startingFen,sansString,selectedIndex,iMadeTheMove) {
  //console.log("StartFen ",startingFen,sansString)
  chess.load(startingFen)

  if (sansString.length > 0) {
    const sans = sansString.split(" ")
    for (var i=0; i < sans.length; i++)
      chess.move(sans[i])
  }

  const chessHistory = chess.history({ verbose: true })
  loadRepTreeFromChessHistory(startingFen,chessHistory,selectedIndex,false,iMadeTheMove)
}

function shiftSelectedMove(direction) {

  //console.log("current selected",currentSelectedMoveIndex)
  if (direction == "back") {
    if (currentSelectedMoveIndex > 0)
      repTreeMoveClick(treeDisplay.value[0].moves[currentSelectedMoveIndex-1])

  }
  else {
    if (currentSelectedMoveIndex < treeDisplay.value[0].moves.length - 1)
      repTreeMoveClick(treeDisplay.value[0].moves[currentSelectedMoveIndex+1])
  }

  setToolbarElementDisabledFlag(toolbarElements.value,TOOLBAR_MAIN_BACK, currentSelectedMoveIndex > 0)
  setToolbarElementDisabledFlag(toolbarElements.value,TOOLBAR_MAIN_FORWARD, currentSelectedMoveIndex <  treeDisplay.value[0].moves.length -1)
    toolbarTrigger.value++
}

function repTreeBranchClick(branchElement) {
  //console.log("Branch Click",branchElement)
}

function repTreeMoveClick(branchElement) {
  //console.log("**** in move click",branchElement)

  const fenPieces = branchElement.move.fen.split(" ")
  whiteToMove.value = (fenPieces[1] == "w")
  //console.log("in reptreemove click white to move",whiteToMove.value)
  fen.value = branchElement.move.fen
  for (var i=0; i < treeDisplay.value[0].moves.length; i++) {
    treeDisplay.value[0].moves[i].selected = (i == branchElement.index)
  }
  currentSelectedMoveIndex = branchElement.index
  //console.log("after seelcted",treeDisplay.value[0])
  treeTrigger.value++

  getAvailableMoves(fen.value,false)

  buildFenMessage() 



}

function appendMoveToTree(san,fen) {

  const firstBranchElement = treeDisplay.value[0].moves[0]

  const startingFenPieces = firstBranchElement.move.fen.split(" ")
  const startingPlyNumber = (startingFenPieces[1] == "w") ? 0 : 1

  // if currently displaying the PGN then save the current index as the place to return to in the PGN
  if (isPGNDisplayed) {
    pgnIndex = currentSelectedMoveIndex
    isPGNDisplayed = false
    setToolbarElementDisabledFlag(toolbarElements.value,TOOLBAR_MAIN_BACK_TO_GAME,true)
    toolbarTrigger.value++
  }

  var oneBranchElement = { 
      index : treeDisplay.value[0].moves.length,
      ply : treeDisplay.value[0].moves.length-1 + startingPlyNumber,
      isOpen : false, selected : false, parentIsOpen : (treeDisplay.value[0].moves.length == 1), 
      move : { san : san, fen : fen, first_move_not_addressed : 0, 
                      percent : 0, comment : '', canBranchAfterThisMove : false , branchIsOpen : false} }
  treeDisplay.value[0].moves.push(oneBranchElement)
}

function buildPGNForClipboard() {

  const todayDate = formatDate(new Date(),".")

  const chessOutput = new Chess()
  chessOutput.load(treeDisplay.value[0].moves[0].move.fen)
  chessOutput.header('Event','Chessvis.com Coaching','Date',todayDate,'Round','1','White','White','Black','Black','Result','*')
  chessOutput.header('Coach',email.value.replace('"','\\""'))
  chessOutput.header('Room',roomName.value.replace('"','\\""'))
  chessOutput.header('Coach',email.value.replace('"','\\""'))

  for (var i=1; i < treeDisplay.value[0].moves.length; i++)
    chessOutput.move(treeDisplay.value[0].moves[i].move.san)

  const pgnText = chessOutput.pgn()
  //console.log("**** PGN ",pgnText)

  return (pgnText)
}

function buildFenMessage() {
  var sans = []

  // first entry is "board" or "game"
  for (var i=1; i < treeDisplay.value[0].moves.length; i++)
    sans.push(treeDisplay.value[0].moves[i].move.san)
  
  const fenJson = {
      fen : treeDisplay.value[0].moves[0].move.fen,
      sans : sans.join(" "),
      index : currentSelectedMoveIndex,

      pgn_sans : pgnSans,
      pgn_index : pgnIndex
  }
    //console.log("******* SEND FEN MESSAGE",fenJson)

    sendMessageToSocket("fen\t" + JSON.stringify(fenJson))
}

function learnMarkupChange(whatType,value) {
  //console.log("learn markup ",whatType,value)
  if (whatType == "color")
    learnMarkupColor.value = value
  else
    if (value == "clear") {
      mainSquareColorArray.value = []
      learnMarkerArray = []
      arrowPairs.value = []
      learnArrowArray = []
      const squareJson = JSON.stringify( { clear : true })
      const socketMessage = "markup_board\t" + squareJson

      sendMessageToSocket(socketMessage)
    }
    else
      learnMarkupAction.value = value

    connectionStore.setMarkupDefaults(learnMarkupColor.value + "," + learnMarkupAction.value)
}

function boardMove(arrayIndex,fromUCI,toUCI,fromNumber,toNumber) {

  if (showState.value == SHOW_ROOM) {
    // if in the room and markup
    if (!showMoves.value)
      return
  }

  if (arrayIndex < 0)
    return

  //console.log("board move",arrayIndex,fromUCI,toUCI,fromNumber,toNumber)
  const oneMove = availableMoves.value[arrayIndex]
  //console.log("MOVE INFO ",oneMove.fen,oneMove.san)

  // if the move is the next move in sequence, then just do a 'forward'
  //    if not, truncate the sequence and append
  if (currentSelectedMoveIndex < treeDisplay.value[0].moves.length-1) {
    //console.log("NEXT FEN",treeDisplay.value[0].moves[currentSelectedMoveIndex+1].move.fen)
    if (oneMove.fen == treeDisplay.value[0].moves[currentSelectedMoveIndex+1].move.fen) {
      shiftSelectedMove("forward")
    }
    else {
      treeDisplay.value[0].moves.length = currentSelectedMoveIndex + 1
      appendMoveToTree(oneMove.san,oneMove.fen)
      shiftSelectedMove("forward")
    }
  }
  else {
    appendMoveToTree(oneMove.san,oneMove.fen)
    shiftSelectedMove("forward")
  }

}

function moveMade(moveFen,uci) {
  if (showState.value == SHOW_ROOM) {

    // if in the room, only interested in this if in markup mode
    if (showMoves.value)
      return

    if (learnMarkupAction.value == "arrow") {
      if (learnArrowFromSquare == "") {
        learnArrowFromSquare = uci
        const newColor = learnMarkupColor.value + "_arrow"
        const oneSquareColor = { color : newColor , square : uci}
        mainSquareColorArray.value = []
        mainSquareColorArray.value.push(oneSquareColor)
        return
      }

      // from/to squares are the same
      if (learnArrowFromSquare == uci) {

        const oneSquareColor = { color : "ignore" , square : uci}
        mainSquareColorArray.value = []
        mainSquareColorArray.value.push(oneSquareColor)

        learnArrowFromSquare = ""
        return
      }

      // get rid of the "from" square 4-point arrow
      const oneSquareColor = { color : "ignore" , square : learnArrowFromSquare}
      mainSquareColorArray.value = []
      mainSquareColorArray.value.push(oneSquareColor)

      //console.log("arrow from to",learnArrowFromSquare,uci)
      const newArrow = learnArrowFromSquare + "-" + uci + "-" + learnMarkupColor.value

      // should we remove the arrow from the list?
      var didRemove = false
      const oldArrowArray = JSON.parse(JSON.stringify(learnArrowArray))
      learnArrowArray = []
      for (var i=0; i < oldArrowArray.length; i++)
        if (newArrow != oldArrowArray[i])
          learnArrowArray.push(oldArrowArray[i])
        else
          didRemove = true
      if (!didRemove)
        learnArrowArray.push(newArrow)

      arrowPairs.value = []
      for (var i=0; i < learnArrowArray.length; i++)
        arrowPairs.value.push(learnArrowArray[i])

      //arrowPairs.value = [learnArrowFromSquare + "-" + uci + "-" + learnMarkupColor.value]
      //arrowPairs.value.push(learnArrowFromSquare + "-" + uci + "-" + learnMarkupColor.value)
      //console.log("arrow pairs ",arrowPairs.value)
      
      learnArrowFromSquare = ""

      const arrowJson = JSON.stringify( { arrows : arrowPairs.value , arrowArray : learnArrowArray, squares : [] , squaresArray : []})
      const socketMessage = "markup_board\t" + arrowJson

      sendMessageToSocket(socketMessage)

      return
    }

    mainSquareColorArray.value = []
    //console.log("markup ",moveFen,uci)

    const newColor = (learnMarkupAction.value == "border") ? learnMarkupColor.value + "_frame" : learnMarkupColor.value
    
    // is the square already in the list? if so, do we change the color or remove it?
    for (var i=0; i < learnMarkerArray.length; i++) {
      if (learnMarkerArray[i].square == uci) {
        if (learnMarkerArray[i].color == newColor)
          learnMarkerArray[i].color = "ignore"
        else
          learnMarkerArray[i].color = newColor
        const oneSquareColor = { color : learnMarkerArray[i].color , square : uci}
        mainSquareColorArray.value.push(oneSquareColor)

        const squareJson = JSON.stringify( { arrows : [] , arrowArray : [], squares : mainSquareColorArray.value, squaresArray : learnMarkerArray })
        const socketMessage = "markup_board\t" + squareJson

        sendMessageToSocket(socketMessage)
  
        return
      }
    }
    const oneSquareColor = { color : newColor, square : uci}
    mainSquareColorArray.value.push(oneSquareColor)
    learnMarkerArray.push(oneSquareColor)
    //console.log("main square colors",mainSquareColorArray.value)

    const squareJson = JSON.stringify( { arrows : [] , arrowArray : [], squares : mainSquareColorArray.value, squaresArray : learnMarkerArray })
    const socketMessage = "markup_board\t" + squareJson

    sendMessageToSocket(socketMessage)

    return
  }

  //console.log("MOVE MADE",moveFen,uci) 
  const moveChar = (whiteToMove.value) ? " w " : " b "
  completeFen = moveFen + moveChar + "KQkq - 0 1"
  const rc = validateFen(completeFen)
  //console.log("validation",rc)
  positionIsValid = rc.ok
  setToolbarElementDisabledFlag(toolbarElements.value,TOOLBAR_BUILD_DONE,!positionIsValid)
  toolbarTrigger.value++
}

// callback from the 2x6 piece board
function boardSelector(arrayIndex,fromUCI,toUCI,fromNumber,toNumber) {
  //console.log("board SELECTOR",arrayIndex,fromUCI,toUCI,fromNumber,toNumber)

  const currentSideCarPiece = sideCarPiece.value

  // landscape is down, portrait is across
  switch (fromUCI) {
    case "a8" :
      sideCarPiece.value = "br"
      break
    case "a7" :
      sideCarPiece.value = (isPortrait) ? "wr" : "bn"
      break
    case "a6" :
    case "c8" :
      sideCarPiece.value = "bb"
      break
    case "a5" :
    case "d8" :
      sideCarPiece.value = "bq"
      break
    case "a4" :
    case "e8" :
      sideCarPiece.value = "bk"
      break
    case "f8" :
    case "a3" :
      sideCarPiece.value = "bp"
      break
    case "b8" :
      sideCarPiece.value = (isPortrait) ? "bn" : "wr"
      break
    case "b7" :
      sideCarPiece.value = "wn"
      break
    case "c7" :
    case "b6" :
      sideCarPiece.value = "wb"
      break
    case "d7" :
    case "b5" :
      sideCarPiece.value = "wq"
      break
    case "e7" :
    case "b4" :
      sideCarPiece.value = "wk"
      break
    case "f7" :
    case "b3" :
      sideCarPiece.value = "wp"
      break
  }

  if (currentSideCarPiece == sideCarPiece.value) {
    squareColorArray.value = [ ]
    sideCarPiece.value = ""
  }
  else
    squareColorArray.value = [ { square : fromUCI , color : "red"}]
}

function validatePasteFen(pasteFen) {
  //console.log(pasteFen)
  const rc = validateFen(pasteFen)
  if (rc.ok) {
    positionIsValid = true
    incrementAppendTrigger()
    fen.value = pasteFen + blankAppendTrigger
    completeFen = pasteFen
    const fenPieces = completeFen.split(" ")
    whiteToMove.value = (fenPieces[1] == "w")
    setToolbarElementLabel(toolbarElements.value,TOOLBAR_BUILD_WHO_MOVE,
                (whiteToMove.value) ? "White to Move" : "Black to Move")
    setToolbarElementDisabledFlag(toolbarElements.value,TOOLBAR_BUILD_DONE,!positionIsValid)
    toolbarTrigger.value++
  }
  else {
    //console.log("validation",rc)
    alert("Clipboard does not contain a valid FEN")
  }
}

function leaveRoom() {
    //console.log("in leave room",personIsCoach)
    if (personIsCoach) {
      // timerCanStop = true
      // I'm coach and I'm leaving, close everyone
      for (const [targetUUID, peerInfo] of peerMap.entries()) {
        
        if (peerInfo.peerConnection != null) {
          const element = document.getElementById(peerInfo.peerConnection.htmlID);
          console.log("remove leave room",peerInfo.peerConnection.htmlID,element)

          if (element != null)
            element.remove()

          peerInfo.peerConnection.close()
          peerInfo.peerConnection = null
        }
      }
      peerMap.clear()

    }
    else {
      // I'm a student, I'm leaving
      if (peerStudentConnection != null) {
        peerStudentConnection.close()
        peerStudentConnection = null
      }
    }
    if (localStream != null)
        localStream.getTracks().forEach(track => track.stop())
    message.value = joinRoomMessage
    showState.value = SHOW_JOIN_ROOM
    audioIsMuted.value = muteAtStart
    toolbarElements.value = []
    toolbarTrigger.value++

    closeSocket()

    console.log("end of leave rooom")
  }

function alertResult(response,task,info) {
  //console.log("Alert Result",response,task)

  switch (task) {
    case "bad" : // bad pgn or fen
      break
    case "leave" :
      if (response == "yes")
        leaveRoom()
      break
    case "copy" :
      switch (response) {
        case "no" :
          return
        case "fen" :
          navigator.clipboard.writeText(fen.value.trim());
          break
        case "pgn" :
          navigator.clipboard.writeText(buildPGNForClipboard())
          break
      }
      break
    case "boardsource" :
      // build board responses
      switch (response) {
        case "no" :
          return
        case "initial" :
          incrementAppendTrigger()
          fen.value = INITIAL_FEN + blankAppendTrigger
          completeFen = INITIAL_FEN
          positionIsValid = true
          setToolbarElementDisabledFlag(toolbarElements.value,TOOLBAR_BUILD_DONE,!positionIsValid)

          whiteToMove.value = true
          setToolbarElementLabel(toolbarElements.value,TOOLBAR_BUILD_WHO_MOVE,"White to Move")
          toolbarTrigger.value++
          break
        case "empty" :
          incrementAppendTrigger()
          fen.value = EMPTY_FEN + blankAppendTrigger
          completeFen = EMPTY_FEN
          positionIsValid = false
          setToolbarElementDisabledFlag(toolbarElements.value,TOOLBAR_BUILD_DONE,!positionIsValid)
          whiteToMove.value = true
          setToolbarElementLabel(toolbarElements.value,TOOLBAR_BUILD_WHO_MOVE,"White to Move")
          toolbarTrigger.value++
          break
        case "paste" :
          navigator.clipboard.readText().then((clipText) => (
            validatePasteFen(clipText)
            ));
          break
      }
    break
  }
}

  // START Generic Options List

function updateMutes(roomSoundString) {
  muteMoveSound = false
  muteChatSound = false
  const roomSounds = roomSoundString.split(",")
  for (var i=0; i < roomSounds.length; i++)
    if (roomSounds[i] == "move")
      muteMoveSound = true
    else
    if (roomSounds[i] == "chat")
      muteChatSound = true
  //console.log("mute move sound",muteMoveSound)
}

const openGenericMultiListModal = async () => {
  var soundOptions = [
      { index : 0, selected : muteMoveSound, name : "Mute Moves", id : "move", radio : "move" },
      { index : 1, selected : muteChatSound, name : "Mute Chat", id : "chat", radio : "chat" }
  ]
    const modal = await modalController.create({
      component: ModalGenericMultiList,
      componentProps: {
        mustHaveLeastOneCheckBox : false,
        displayArray : soundOptions,
        title : soundTitle      }
    });

    modal.present();

    const { data, role } = await modal.onWillDismiss();

    if (role === 'confirm') {
      //console.log("CONFIRM in multi",data)
      updateMutes(data)
      connectionStore.setRoomSounds(data)
    }
  };
  // END Generic Options List

function buildBoardToolbarClick(arrayIndex) {

  var completePieces = []

  switch (arrayIndex) {
    case TOOLBAR_BUILD_PGN :
      navigator.clipboard.readText().then((clipText) => {
        isPGN = true
        pgnToTreeDisplay(clipText)
        buildBoardToolbarClick(TOOLBAR_BUILD_DONE_FROM_PGN)
      });
      break

    case TOOLBAR_BUILD_FEN :
      alertInfo.value = { header : "Board Source" , 
              message : "Preset Board to:", type : "boardsource", task : "boardsource"  }
      alertTrigger.value++
      break
    case TOOLBAR_BUILD_WHO_MOVE :
      whiteToMove.value = !whiteToMove.value
      const moveChar = (whiteToMove.value) ? "w" : "b"
      completePieces = completeFen.split(" ")
      completePieces[1] = moveChar
      completeFen = completePieces.join(" ")
      setToolbarElementLabel(toolbarElements.value,TOOLBAR_BUILD_WHO_MOVE,
                (whiteToMove.value) ? "White to Move" : "Black to Move")
      break
    case TOOLBAR_BUILD_DONE :
    case TOOLBAR_BUILD_DONE_FROM_PGN :

      squareColorArray.value = []
      mainSquareColorArray.value = []
      sideCarPiece.value = ""
      toolbarElements.value = JSON.parse(JSON.stringify(toolbarMainElements))
      toolbarElements.value.push((personIsCoach) ? toolbarMainCoachElement : toolbarMainStudentElement)
      toolbarTrigger.value++
      showState.value = SHOW_ROOM

      // fix up the castling based on where the pieces are
      if (arrayIndex == TOOLBAR_BUILD_DONE) {
        pgnSans = ""
        pgnIndex = 0
        isPGN = false
        isPGNDisplayed = false
        chess.load(completeFen)
        const board = chess.board()
        const cleanCastling = buildCastleString(board)
        completePieces = completeFen.split(" ")
        completePieces[2] = cleanCastling
        completeFen = completePieces.join(" ")

        incrementAppendTrigger()
        fen.value = completeFen + blankAppendTrigger

        //console.log("**** BACK FROM BUILD",completeFen)
        loadRepTreeFromChessHistory(completeFen,[],0,true,false)
        buildFenMessage() 
      }
      break
  }
}

// stuff for options

// Start ACTION LIST
function actionSheetResult(action,index) {
  if (action != "yes")
    return
  actionClick(index)
}

function setupAlert(header,message,type,task) {
  alertInfo.value = { header : header, message : message, type : type, task : task  }
  alertTrigger.value++
}

function actionClick(index) {
  switch (index) {
    case ACTION_COACH_OPTION_COPY :
    case ACTION_STUDENT_OPTION_COPY :
      setupAlert("Copy to Clipboard?","You can copy the current board or entire move sequence to the clipboard","boardmoves","copy")
      break
    case ACTION_COACH_OPTION_SOUNDS :
    case ACTION_STUDENT_OPTION_SOUNDS :
      openGenericMultiListModal()
      break
    case ACTION_STUDENT_OPTION_SESSION_TIMER :
      if (sessionTimerAvailableForStudent) {
        showSessionTimer.value = !showSessionTimer.value 
        updateWidthHeights()
      }
      break
    case ACTION_COACH_OPTION_ENGINE :
      showEngineScores.value = !showEngineScores.value

      // if we need the space or don't need it anymore, allocate it
      if (showSessionTimer.value == false)
        updateWidthHeights()
      if (showEngineScores.value)
        getMultiPV(fen.value)
      break
    case ACTION_COACH_OPTION_SESSION_TIMER :
      //learnPreferencesModal()
      if (showSessionTimer.value == false) {
        sessionTimerStartTime = Math.floor(Date.now() / 1000)
        connectionStore.setSessionTimer(email.value + "\t" + roomName.value + "\t" + sessionTimerStartTime)
        showSessionTimer.value = true
        displayTimer(0)
        // timerCanStop = false
        // startTimer()
        sendTimerMessage(0)
      }
      else {
        sendTimerMessage("off")
        connectionStore.setSessionTimer("")
        // timerCanStop = true
        showSessionTimer.value = false
      }
      // if we need the space or don't need it anymore, allocate it
      if (showEngineScores.value == false)
        updateWidthHeights()
      break
    case ACTION_COACH_OPTION_LEAVE_ROOM :
    case ACTION_STUDENT_OPTION_LEAVE_ROOM :
      setupAlert("Leave Room?","Do you want to leave the room?","yesno","leave")
      break
    case ACTION_COACH_OPTION_FLIP_BOARD :
    case ACTION_STUDENT_OPTION_FLIP_BOARD :
      orientation.value = (orientation.value == "white") ? "black" : "white"
      break
    case ACTION_COACH_OPTION_BUILD_BOARD:
    case ACTION_STUDENT_OPTION_BUILD_BOARD:
      squareColorArray.value = []
      mainSquareColorArray.value = []
      toolbarElements.value = toolbarBuildBoardElements
      toolbarTrigger.value++
      availableMoves.value = availableMovesForBuilder
      orientation.value = "white"
      incrementAppendTrigger()
      selectorFen.value = ((isPortrait) ? SELECTOR_FEN_PORTRAIT : SELECTOR_FEN_LANDSCAPE) + blankAppendTrigger
      showState.value = SHOW_BUILD_BOARD
      break
   
  }
}

// END Action List

function toggleMarkupMode(fromToolbar) {

  //console.log("**** in togglemarkup ",showMoves.value)
  if (fromToolbar)
    showMoves.value = !showMoves.value

  if (showMoves.value) {
    setToolbarElementLabel(toolbarElements.value,TOOLBAR_MAIN_MARKUP,"Mark-Up")
    toolbarElements.value[TOOLBAR_MAIN_MARKUP].icon = colorPaletteOutline

    // restore the avaiable move list
    availableMoves.value = saveAvailableMoves
    sideCarPiece.value = ""
    mainSquareColorArray.value = []
    learnMarkerArray = []
    learnArrowArray = []
    learnArrowFromSquare = ""
    arrowPairs.value = []
  }
  else {
    setToolbarElementLabel(toolbarElements.value,TOOLBAR_MAIN_MARKUP,"Moves")
    toolbarElements.value[TOOLBAR_MAIN_MARKUP].icon = arrowUndoOutline

    // save the available moves when playing and load in dummy values for markup
    saveAvailableMoves = availableMoves.value
    availableMoves.value = []
    sideCarPiece.value = "markup"
    learnMarkerArray = []
    learnArrowArray = []
    arrowPairs.value = []
  }
  toolbarTrigger.value++
}

function mainToolBarClick(arrayIndex) {
  var message = ""

  // trap that the button should be disabled but the screen hasn't caught up
  var element = findToolbarElement(toolbarElements.value,arrayIndex)
  if (element != null && element.disabled)
    return

  switch (arrayIndex) {
    case TOOLBAR_MAIN_MARKUP :
      toggleMarkupMode(true)
      const markupInfo = JSON.stringify({ inMarkup : (!showMoves.value) })
      const message = "markup\t" + markupInfo

      sendMessageToSocket(message)  
      break
    case TOOLBAR_MAIN_FORWARD :
      shiftSelectedMove("forward")
      break
    case TOOLBAR_MAIN_BACK :
      shiftSelectedMove("back")
      break
    case TOOLBAR_MAIN_BACK_TO_GAME :
      if (isPGN == false || isPGNDisplayed == true)
        break

      const startingFen = treeDisplay.value[0].moves[0].move.fen
      const sans = pgnSans
      currentSelectedMoveIndex = pgnIndex
      fenSansToTreeDisplay(startingFen,sans,pgnIndex,true)
      setToolbarElementDisabledFlag(toolbarElements.value,TOOLBAR_MAIN_BACK_TO_GAME,true)
      toolbarTrigger.value++
      buildFenMessage() 
      break
    case TOOLBAR_MAIN_COACH :
      actionSheetButtons.value = coachActionSheetButtons

      coachActionSheetButtons[ACTION_COACH_OPTION_SESSION_TIMER - ACTION_COACH_OPTION_INDEX].text =
              (showSessionTimer.value) ? "Stop Session Timer" : "Start Session Timer"
      coachActionSheetButtons[ACTION_COACH_OPTION_ENGINE - ACTION_COACH_OPTION_INDEX].text =
              (showEngineScores.value) ? "Stop Engine Score Display" : "Start Engine Score Display"
      actionSheetTrigger.value++
      break
    case TOOLBAR_MAIN_STUDENT :
      if (sessionTimerAvailableForStudent) {
        studentActionSheetButtons[ACTION_STUDENT_OPTION_SESSION_TIMER - ACTION_STUDENT_OPTION_INDEX].text =
              (showSessionTimer.value) ? "Hide Session Timer" : "Show Session Timer"
      }
      else {
        studentActionSheetButtons[ACTION_STUDENT_OPTION_SESSION_TIMER - ACTION_STUDENT_OPTION_INDEX].text =
              "No Session Timer"
      }
      actionSheetButtons.value = studentActionSheetButtons
      actionSheetTrigger.value++
      break
  }
}

function toolbarClick(arrayIndex) {
  //console.log("toolbar click",showState,arrayIndex)
  switch (showState.value) {
    case SHOW_BUILD_BOARD :
      buildBoardToolbarClick(arrayIndex)
      break
    case SHOW_ROOM :
      mainToolBarClick(arrayIndex)
      break
  }
}

function getAvailableMoves(fenString,noNeedToCallEngine) {
  //console.log("******* IN AVAILABLE MOVES",fenString)
  // var fenPieces = fen.split(" ")
  // fenPieces[5] = 1
  // const fenFixed = fenPieces.join(" ")
  chess.load(fenString)
  const moves = chess.moves({ verbose: true })
  availableMoves.value = buildAvailableMoves(moves,true)
  //console.log("available moves",availableMoves.value)

  // if (personIsCoach && !noNeedToCallEngine && showEngineScores.value)
  //   getMultiPV(fenString)
}

let toggleMicStream = async () => {
    let audioTrack = localStream.getTracks().find(track => track.kind === 'audio')
    audioTrack.enabled = !audioIsMuted.value
    console.log("audio is muted",audioIsMuted.value)
    console.log("toggle mic stream",audioTrack)
}

function setMicMuted(newState) {
  audioIsMuted.value = newState
  //localStream.getAudioTracks()[0].enabled = !audioIsMuted.value

  toggleMicStream()
}

function sendTypedMessage() {
  if (chatMessage.value.length == 0)
    return
  const message = "typed\t" + chatMessage.value
  chatMessage.value = ""

  sendMessageToSocket(message)
}

function addMessageToChat(senderParticipantType,senderDisplayName,messageText,senderUUID) {

  var messageType = ""

  if (senderParticipantType == "student") {
    if (displayName.value == senderDisplayName)
      messageType = "me_student"
    else
      messageType = "student"
  }
  else {
    if (displayName.value == senderDisplayName)
      messageType = "me_coach"
    else
      messageType = "coach"
    coachHasJoinedRoom.value = true
  }
  const oneChat = { id : bigChatDisplayArray.length , name: senderDisplayName, type : messageType, text : messageText }
  bigChatDisplayArray.push(oneChat)

  // trim array if too big
  const firstChatIndex = (bigChatDisplayArray.length > chatDisplayCount) ? bigChatDisplayArray.length - chatDisplayCount : 0
  chatDisplayArray.value = []
  for (var i=firstChatIndex; i < bigChatDisplayArray.length; i++)
    chatDisplayArray.value.push(bigChatDisplayArray[i])

  // don't play sound on my chat
  if (senderUUID != myUUID && inRecents == false && muteChatSound == false)
    playChatSound()

}

function processMessageFromSocket(data) {
  var messageJson = null
  var fenPieces = []
  //console.log("socket data -> ",data)

  const messagePieces = data.split("\t")

  if (messagePieces[0] == "ping") {
    ///console.log("got ping")
    return
  }

  const senderDisplayName = messagePieces[0]
  const senderParticipantType = messagePieces[1]
  const senderIsCoach = (senderParticipantType == "coach")

  const extrasJson = (messagePieces.length >= 4) ? JSON.parse( messagePieces[messagePieces.length-1]) : { 'senderUUID' : "0", 'audioVideo' : 'none'}
  const senderUUID = extrasJson.senderUUID

  switch (messagePieces[2]) {
    case "Welcome" :
      sendSocketFirstMessage()
      break
    case "markup_board" :
      // changes already made on the  sender machine
      if (senderUUID == myUUID && !inRecents)
        break

      const markupBoardJson = JSON.parse(messagePieces[3])

      if (markupBoardJson.clear == true) {
        mainSquareColorArray.value = []
        learnMarkerArray = []
        arrowPairs.value = []
        learnArrowArray = []
        learnArrowFromSquare = ""
        break
      }
      if (markupBoardJson.arrows.length > 0)
        arrowPairs.value = markupBoardJson.arrows
      if (markupBoardJson.arrowArray.length > 0)
        learnArrowArray = markupBoardJson.arrowArray

      learnArrowFromSquare = ""

      if (markupBoardJson.squares.length > 0)
        mainSquareColorArray.value = markupBoardJson.squares
      if (markupBoardJson.squaresArray.length > 0)
        learnMarkerArray = markupBoardJson.squaresArray
      break
    case "markup" :

      // changes already made on the  sender machine
      if (senderUUID == myUUID && !inRecents)
        break

      const markupJson = JSON.parse(messagePieces[3])

      showMoves.value = !markupJson.inMarkup
      toggleMarkupMode(false)
      break
    case "timer" :
      // only coach sends timer messages so if uuid is the same, ignore
      if (senderUUID == myUUID)
        break
      const timerJson = JSON.parse(messagePieces[3])

      const sessionSeconds = timerJson.seconds
      if (sessionSeconds == "off") {
        showSessionTimer.value = false
        sessionTimerAvailableForStudent = false
        break
      }
      displayTimer(sessionSeconds)
      sessionTimerAvailableForStudent = true
      break
    case "webrtc" :
      if (inRecents)
        break
      const webrtcMessage = messagePieces[3]
      gotMessageFromServer(webrtcMessage)
      break
    case "start_recent" :
      inRecents = true
      break
    case "end_recent" :
      inRecents = false

      //console.log("******** PEER MAP",peerMap)
      // did the audio get turned on by the activities before you joined?

      break
    case "typed" :
      addMessageToChat(senderParticipantType,senderDisplayName,messagePieces[3],senderUUID)
      break
    case "join" :
      addMessageToChat(senderParticipantType,senderDisplayName,messagePieces[3],senderUUID)

      // if I'm the sender & coach, see if any already joined students need peer connections made
      // otherwise, I'm done
      if (senderUUID == myUUID) {
        if (audioIsOn.value && personIsCoach)
          startPeerConnections()
        break
      }
      peerMap.set(senderUUID, { uuid : senderUUID, connection : null, audioVideo : extrasJson.audioVideo})

      // if my audio is on and so is the other person, then start the peer connection
      if (audioIsOn.value && extrasJson.audioVideo == "audio")
        startOnePeerConnection(senderUUID,peerMap.get(senderUUID))

      break
    case "leave" :
      addMessageToChat(senderParticipantType,senderDisplayName,messagePieces[3],senderUUID)

      //console.log("leave",personIsCoach,senderUUID,myUUID)
      // if I'm coach and the person leaving isn't me, close the one connection
      if (personIsCoach) {
        if (senderUUID != myUUID) {
          const peerInfo = peerMap.get(senderUUID)
          if (peerInfo.peerConnection != null) {
            const element = document.getElementById(peerInfo.peerConnection.htmlID);
            console.log("remove message ",peerInfo.peerConnection.htmlID,element)

            if (element != null)
              element.remove()

            peerInfo.peerConnection.close()
          }
          peerMap.delete(senderUUID)
          //console.log("remove connection")
        }
        else {
          // I'm coach and I'm leaving, close everyone
          for (const [targetUUID, peerInfo] of peerMap.entries()) {
            if (peerInfo.peerConnection != null) {
              const element = document.getElementById(peerInfo.peerConnection.htmlID);
              console.log("remove everyone ",peerInfo.peerConnection.htmlID,element)

              if (element != null)
                element.remove()

              peerInfo.peerConnection.close()
            }
          }
          peerMap.clear()
        }
      }
      else {
        // I'm a student, and only care if I'm leaving
        if (senderUUID == myUUID) {
          if (peerStudentConnection != null) {
            peerStudentConnection.close()
            peerStudentConnection = null
          }
        }
      }

      break
    case "fen" :

      // ignore fen commands I made
      // if (senderUUID == myUUID)
      //   break

      coachHasJoinedRoom.value = true
      const fenJson = JSON.parse(messagePieces[3])
      //console.log("** Received FEN JSON ",fenJson)

      // is there a PGN going along for the ride?
      if (fenJson.pgn_sans == undefined || fenJson.pgn_sans.length == 0) {
        pgnSans = ""
        pgnIndex = 0
        isPGN = false
        isPGNDisplayed = false
      }
      else {
        pgnSans = fenJson.pgn_sans
        pgnIndex = fenJson.pgn_index
        isPGN = true
        isPGNDisplayed = (pgnSans == fenJson.sans)
      }

      setToolbarElementDisabledFlag(toolbarElements.value,TOOLBAR_MAIN_BACK_TO_GAME,!isPGN || isPGNDisplayed)

      //console.log("**** FEN  PGN",fenJson.pgn)
      fenSansToTreeDisplay(fenJson.fen,fenJson.sans,fenJson.index,senderUUID == myUUID)
      toolbarTrigger.value++
      break

  }

  const bottom_element = document.getElementById('bottom-element');
  bottom_element.scrollIntoView({ behavior: "smooth" })
  bottom_element.scrollIntoView(true)
}

function scrollToId(id) {
  const yOffset = document.getElementById(id).offsetTop;
  content.value.$el.scrollToPoint(0,yOffset -100 ,200)
}

const getAudioVideoPermissions = async () => {

  const localID = (showVideo.value) ? "localVideo" : "localAudio"
  localAudioVideo = document.getElementById(localID);

  const videoConstraints = {
    video: {
      width:{min:100, ideal:100, max:100},
      height:{min:100, ideal:100, max:100},
  },
    audio: true,
  }

  const audioConstraints = {
    video: false,
    audio: true,
  }

  const constraints = (showVideo.value) ? videoConstraints : audioConstraints

  if(!navigator.mediaDevices.getUserMedia) {
    alert('Your browser does not support getUserMedia API');
    createSocketConnection("none") 
    return;
  }

  try {
    const stream = await navigator.mediaDevices.getUserMedia(constraints);

    audioIsOn.value = true
    localStream = stream;

    // start muted
    var audioTrack = localStream.getTracks().find(track => track.kind === 'audio')
    audioTrack.enabled = !muteAtStart

    localAudioVideo.srcObject = stream;
    if (personIsCoach) {
      didStartPeerConnections = true
      startPeerConnections()
    }
    createSocketConnection(checkAudioVideo.value) 
  } catch(error) {
    alert('Your browser has blocked chessvis.com from using the microphone');
    createSocketConnection("none") 
    //errorHandler(error);
  }

  //console.log("END OF getAudioVideoPermissions")
}

function createSocketConnection(audioVideoCapabilities) {
  // send first message
  const cookie = connectionStore.getCookie
  var elementArray = []
  elementArray.push("first")
  elementArray.push(cookie)
  elementArray.push(email.value)
  elementArray.push(roomName.value)
  elementArray.push(displayName.value)
  elementArray.push(personType)

  const extras = JSON.stringify({'uuid' : myUUID, 'audioVideo' : audioVideoCapabilities})
  elementArray.push(extras)

  const sendString = elementArray.join("\t")

  sendMessageToSocket(sendString)

  toolbarElements.value = JSON.parse(JSON.stringify(toolbarMainElements))
  toolbarElements.value.push( (personIsCoach) ? toolbarMainCoachElement : toolbarMainStudentElement)
  toolbarTrigger.value++
}

function toggleCheckAudioVideo() {
  checkAudioVideo.value = (checkAudioVideo.value == "audio") ? "none" : "audio"
  connectionStore.setCheckAudioVideo(checkAudioVideo.value)
  enableVoiceChat.value = (checkAudioVideo.value == "audio")
  console.log("audio value",checkAudioVideo.value)
}

function displayTimer(seconds) {
  const onlySeconds = seconds % 60
  const minutes = Math.floor(seconds / 60)
  const onlyHours = Math.floor(minutes / 60)
  const onlyMinutes = minutes % 60

  if (personIsCoach)
    sessionTimerString.value = onlyHours + ":" + ((onlyMinutes < 10) ? "0" : "") + onlyMinutes + ":" + 
                  ((onlySeconds < 10) ? "0" : "") + onlySeconds
  else
    sessionTimerString.value = onlyHours + ":" + ((onlyMinutes < 10) ? "0" : "") + onlyMinutes
}

function sendTimerMessage(seconds) {
  if (showSessionTimer.value) {
    const oneTimerMessage = { seconds : seconds}

    sendMessageToSocket("timer\t" + JSON.stringify(oneTimerMessage))

    //console.log("Timer message sent")
  }
}

function startTimer() {
  
  function oneSecondInterval() {
    if (timerCanStop) {
      clearInterval(id)
      return
    }

    // send ping every # seconds
    absoluteSecondsCounter++
    if ((absoluteSecondsCounter % pingSeconds) == 0) {
      //console.log("send ping")
      sendMessageToSocket("ping\t" + myUUID)
    }

    // if timer is also being used by coach for session timer display
    if (personType == "coach" && showSessionTimer.value) {
      const timeNow = Math.floor(Date.now() / 1000)

      // coach sees seconds. send to student, once a minute
      const seconds = Math.floor((timeNow - sessionTimerStartTime))
      displayTimer(seconds)

      if ((seconds % 60) == 0) {
        sendTimerMessage(seconds)
      }
    }
  }
  var id = setInterval(oneSecondInterval, 1000)
}

function enterRoom(personTypePassed) {

  if (audioContext != null)
    audioContext.resume().then(() => console.log("Resume?", audioContext.state))
  else
    console.log("no audio Context")

  personType = personTypePassed
  openSocket()
}

function sendSocketFirstMessage() {
  connectionStore.setLearnCoachEmail(email.value)
  connectionStore.setLearnRoomName(roomName.value)
  connectionStore.setLearnDisplayName(displayName.value)
  personIsCoach = (personType == "coach")

  chessForEngineScore = (personIsCoach) ? new Chess() : null

  // is there an active session timer?   (I.e., did they leave and enter room)
  const existingTimer = connectionStore.getSessionTimer
  if (personIsCoach && existingTimer.length > 0) {
    const timerPieces = existingTimer.split("\t")
    if (timerPieces.length == 3 && timerPieces[0] == email.value && timerPieces[1] == roomName.value) {
      sessionTimerStartTime = parseInt(timerPieces[2])
      showSessionTimer.value = true

      // get going with current value
      const timeNow = Math.floor(Date.now() / 1000)
      const seconds = Math.floor((timeNow - sessionTimerStartTime))
      displayTimer(seconds)

      // timerCanStop = false
      // startTimer()
      sendTimerMessage(seconds)
      updateWidthHeights()
    }
    else
      showSessionTimer.value = false
  }
  else
    showSessionTimer.value = false

  //console.log("IN enter room",personType,checkAudioVideo.value )

  showAudioVideo.value = (checkAudioVideo.value == 'audio')
  showState.value = SHOW_ROOM

  // if audio or video is desired, request permissions from the user before creating the socket connection
  // but first get the turn servers
  if (checkAudioVideo.value == "audio" || checkAudioVideo.value == "video") {
    getTurnServers()
  }
  else {
    audioIsOn.value = false
    createSocketConnection("none")
  }
  //sendMessageToSocket(email.value)
}

function startOnePeerConnection(targetUUID,peerInfo) {

  var onePeerConnection = new RTCPeerConnection(peerConnectionConfig);
  onePeerConnection.hasAudioVideoElement = false

  onePeerConnection.onicecandidate = (event) => {
    if(event.candidate != null) {
      sendMessageToSocket("webrtc\t" + JSON.stringify({'ice': event.candidate, 'myUUID': 'coach', 'targetUUID' : targetUUID }));
    }
  };

  onePeerConnection.oniceconnectionstatechange = () => {
    const state = onePeerConnection.iceConnectionState;
    //console.log("one Peer State",state)

    const debugMessage = "debug\tone peer state change " + state
    sendMessageToSocket(debugMessage)
    
    if (state === "failed" || state === "closed") {
        // connection to the peer is lost and unsalvageable, run cleanup code
    } else if (state === "disconnected") {
        // do nothing in the "disconnected" state as it appears to be a transient 
        // state that can easily return to "connected" - I've seen this with Firefox
    }
  };

  onePeerConnection.ontrack = (event) => {
    //console.log("**** event",event)
    var peerConnection = event.target

    if (showVideo.value && event.track.kind != "video")
      return
    if (!showVideo.value && event.track.kind != "audio")
      return

    if (peerConnection.hasAudioVideoElement)
      return

    //console.log('****************  got remote stream',peerConnection.remoteAudioVideoID);

    const divAudioVideos = document.getElementById("audio-videos");

    var audioVideo = document.createElement((showVideo.value) ? "video" : "audio");
    audioVideo.autoplay = true;
    audioVideo.playsinline = true
    audioVideo.muted = false
    audioVideo.className = "video-player"
    audioVideo.height = 100
    audioVideo.width = 100
    audioVideo.id = targetUUID
    audioVideo.srcObject = event.streams[0];
    divAudioVideos.appendChild(audioVideo)

    peerConnection.hasAudioVideoElement = true
    peerConnection.htmlID = targetUUID
  };

  for(const track of localStream.getTracks()) {

    // start audio in mute mode
    // if (track.kind === 'audio')
    //   track.enabled = false
    //localStream.getAudioTracks()[0].enabled = false
    onePeerConnection.addTrack(track, localStream);
  }

  if(didStartPeerConnections) {
    //console.log("***** before create offer")
    createOneOffer(onePeerConnection,"coach",targetUUID)
    //console.log("***** after create offer")

  }

  onePeerConnection.remoteAudioVideoID = targetUUID
  peerInfo.peerConnection = onePeerConnection
}

function startPeerConnections() {

  //console.log("**** PEERS",peerMap)
  for (const [targetUUID, peerInfo] of peerMap.entries()) {
    //console.log("**** PEER SET   ",targetUUID, peerInfo);
    startOnePeerConnection(targetUUID,peerInfo)
  }
  //console.log("**** PEERS at end of loop",peerMap)
}

function createOneOffer(peerConnection,myuuid, targetuuid) {

  const debugMessage = "debug\tcreateOneOffer"
  sendMessageToSocket(debugMessage)

  peerConnection.createOffer().then((offer) => createdDescription(offer,peerConnection,"coach",targetuuid,"offer")).catch(errorHandler);
} 

function createOneAnswer(peerConnection,myuuid, targetuuid) {

  const debugMessage = "debug\tcreateOneAnswer"
  sendMessageToSocket(debugMessage)

  peerConnection.createAnswer().then((answer) => createdDescription(answer,peerConnection,myuuid,targetuuid,"answer")).catch(errorHandler);
} 


function startStudentPeerConnection() {

  var onePeerConnection = new RTCPeerConnection(peerConnectionConfig);
  onePeerConnection.hasAudioVideoElement = false
  onePeerConnection.onicecandidate = (event) => {
    if(event.candidate != null) {
      sendMessageToSocket("webrtc\t" + JSON.stringify({'ice': event.candidate, 'myUUID': myUUID, 'targetUUID' : 'coach'}));
    }
  };

  onePeerConnection.oniceconnectionstatechange = () => {
    const state = onePeerConnection.iceConnectionState;
    //console.log("Student Peer State",state)

    const debugMessage = "debug\tstudent state change " + state
    sendMessageToSocket(debugMessage)

    if (state === "failed" || state === "closed") {
        // connection to the peer is lost and unsalvageable, run cleanup code
    } else if (state === "disconnected") {
        // do nothing in the "disconnected" state as it appears to be a transient 
        // state that can easily return to "connected" - I've seen this with Firefox
    }
  };

  onePeerConnection.ontrack = (event) => {
      //console.log("**** event",event)
      //console.log('got remote stream');

      const remoteID = (showVideo.value) ? "remoteVideo" : "remoteAudio"
      var remoteAudioVideo = document.getElementById(remoteID);
      remoteAudioVideo.srcObject = event.streams[0];
    };

  for(const track of localStream.getTracks()) {
    onePeerConnection.addTrack(track, localStream);
  }
  peerStudentConnection = onePeerConnection
}

function handleSignalSDP(onePeerConnection,signal,oneMyUUID,oneTargetUUID) {

  const debugMessage = "debug\thandleSignalSDP"
  sendMessageToSocket(debugMessage)

  onePeerConnection.setRemoteDescription(new RTCSessionDescription(signal.sdp)).then(() => {

    //console.log("*** In set remote description",signal.sdp.type)

    // Only create answers in response to offers
    if(signal.sdp.type !== 'offer') 
      return;

    //console.log("before create answer")
    createOneAnswer(onePeerConnection,oneMyUUID,oneTargetUUID)
    //console.log("after create answer")
  }
  ).catch(errorHandler);
}

function handleOneIce(onePeerConnection,signal) {

  const debugMessage = "debug\thandleOneIce"
  sendMessageToSocket(debugMessage)

  onePeerConnection.addIceCandidate(new RTCIceCandidate(signal.ice)).catch(errorHandler);
}

function gotMessageFromServer(messageData) {
  if(!didStartPeerConnections && peerStudentConnection == null) 
    startStudentPeerConnection();

  const signal = JSON.parse(messageData);

  //console.log("*** SIGNAL  ",signal.myUUID,signal.targetUUID)

  // Ignore messages from ourself
  if ((!didStartPeerConnections && signal.myUUID == myUUID) || (didStartPeerConnections && signal.myUUID == "coach"))
    return

  // Ignore messages not meant for me
  if ((!didStartPeerConnections && signal.targetUUID != myUUID) || (didStartPeerConnections && signal.targetUUID != "coach"))
    return

  var onePeerConnection = (didStartPeerConnections) ? peerMap.get(signal.myUUID).peerConnection : peerStudentConnection
  var oneTargetUUID =   (didStartPeerConnections) ? onePeerConnection.targetUUID : "coach"
  var oneMyUUID = (didStartPeerConnections) ? "coach" : myUUID
  if(signal.sdp) {
    handleSignalSDP(onePeerConnection,signal,oneMyUUID,oneTargetUUID)
  } 
  else 
    if(signal.ice) {
      handleOneIce(onePeerConnection,signal)
    }
}

function createdDescription(description,peerConnectionToUse,useMyUUID,targetUUID) {
  //console.log('got description',description);
  //console.log('      **** extra text in description',peerConnectionToUse)
  //console.log("       uuids",useMyUUID,targetUUID)

  const debugMessage = "debug\tsetLocalDescription"
  sendMessageToSocket(debugMessage)

  peerConnectionToUse.setLocalDescription(description).then(() => {
    sendMessageToSocket("webrtc\t" + JSON.stringify({'sdp': peerConnectionToUse.localDescription, 'myUUID': useMyUUID, 'targetUUID' : targetUUID}));
  }).catch(errorHandler);
}

function errorHandler(error) {
  console.log("################################## -> ",error);
  const debugMessage = "debug\terror\t" + error
  sendMessageToSocket(debugMessage)
}


function processMultiPVResponse(json) {
  //console.log(" in multipv json callback",json)
  if (json.hasOwnProperty('error')) {
    openErrorModal(json['programRun'],json['error'])
    return;
  }

  const sentFen = json['fen']
  const result = json['r']

  const resultPieces = result.split("\t")
  const scores = resultPieces[0].split(",")
  const ucis = resultPieces[1].split(",")

  var displayScores = []
  var displaySans = []
  var displayStrings = []
  for (var i=0; i < scores.length; i++) {
    if (scores[i] == "ERR") {
      displaySans.push("No Move")
      displayScores.push("")
      continue
    }

    const oneScore = scores[i]
    const oneUCI = ucis[i]
    const from = oneUCI.substring(0,2)
    const to = oneUCI.substring(2,4)
    const promotion = (oneUCI.length > 4) ? oneUCI[4] : ""
    var moveObject = { from : from, to : to}

    // only promote with queen
    if (promotion.length == 1)
      if (promotion == "q")
        moveObject.promotion = promotion
      else
        continue

    chessForEngineScore.load(sentFen)
    const returnedMoveObject = chessForEngineScore.move(moveObject)
    //console.log("Returned ",returnedMoveObject)

    displaySans.push(returnedMoveObject.san)

    const scoreType = oneScore[0]
    const scoreNumber = parseInt(oneScore.substring(1))
    
    if (scoreType == "m")
      displayScores.push("Mate(" + scoreNumber + ")")
    else
    if (scoreType == "p")
      displayScores.push(scoreNumber/100)
    else
      displayScores.push("unk(" + oneScore + ")")
  }

  for (var i=0; i < displayScores.length; i++)
    displayStrings.push("<b>" + displaySans[i] + "</b>" + " " + displayScores[i])
  const combinedDisplayString = displayStrings.join(" / ")

  const combinedResult = { scores : displayScores, sans : displaySans , displayString : combinedDisplayString}
  //console.log("Combined",combinedResult)
  engineScoreMap.set(sentFen,combinedResult)

  // if the current displayed FEN is the one we just got back, display it
  if (fen.value.trim() == sentFen) {
    const oneCombined =  engineScoreMap.get(sentFen)
    scoreDisplayString.value = oneCombined.displayString
    //console.log("IN JSON ",scoreDisplayString.value)
  }
}

  function getMultiPV(sendFen) {
    const fenTrimmed = sendFen.trim()

    if (engineScoreMap.has(fenTrimmed)) {
      scoreDisplayString.value = engineScoreMap.get(fenTrimmed).displayString
      return
    }

    // hard code the INITAL FEN engine scores so they don't have to be gotten from server
    if (sendFen == INITIAL_FEN) {
      processMultiPVResponse(INITIAL_FEN_ENGINE_SCORES)
      return
    }

    scoreDisplayString.value = "<i>Calculating...</i>"

    var formData = {
      fen : sendFen.trim()
    }
    useGetData("chessvis_shared_room_multipv.php", formData, processMultiPVResponse)
  }

  function processTURNServersResponse(json) {
    //console.log(" in turn server json callback",json)
    if (json.hasOwnProperty('error')) {
      openErrorModal(json['programRun'],json['error'])
      return
    }
  
    const which = json['which']
    const turn = json['turn']
    //console.log("TURN STRING ",turn)
    const turnJson = JSON.parse(turn)

    //console.log("TURN JSON",turnJson)

    if (which == "m" || which == "t") {
      peerConnectionConfig.iceServers = turnJson.iceServers
    }
    else {
      const iceServers = turnJson.iceServers
      //console.log("**** ICE URLS ",iceServers)
      peerConnectionConfig.iceServers = iceServers
    }
    getAudioVideoPermissions(personType)

  }

  function getTurnServers() {
  
    var formData = {
      fen : INITIAL_FEN
    }
    useGetData("chessvis_shared_room_fen_info.php", formData, processTURNServersResponse)
  }

</script>

<style scoped>

.chat-window-dark {
  background-color : rgb(30,30,30);
}
.chat-window-light {
  background-color : #e5e5e5;
}

.chat-welcome {
  text-align : center;
  font-weight: bold;
  margin-top : 10px;
}

.chat-bubble {
  margin : 5px;
  padding : 5px;
  border-radius: 10px;
  border: 1px solid black;
  width: fit-content;
}

.chat-other-dark {
  text-align : left;
  font-weight : normal;
  background-color: rgb(59,59,61);
  color : white;
}

.chat-me-dark {
  text-align : right;
  background-color: rgb(66,131,247);
  color : white;
  margin-left: auto;
  margin-right: 0;
  font-weight: normal;
}

.chat-other-light {
  text-align : left;
  font-weight : normal;
  background-color: rgb(233,233,235);
  color : rgb(36,36,36);
}

.chat-me-light {
  text-align : right;
  background-color: rgb(54,122,246);
  color : white;
  margin-left: auto;
  margin-right: 0;
  font-weight: normal;
}

.item {
  margin:5px auto;
}

.invisible-bottom-element {
  visibility : hidden;
  height : 1.2rem;
  margin : 10px;
}

.video-player {
  background-color: blue;
  width: 100px;
  height: 100px;
  display: inline-block;
  /* object-fit: cover; */
}


.audio-player {
  background-color: red;
  width: 100px;
  height: 100px;
  display: inline-block;
  /* object-fit: cover; */
}

</style>
